import classNames from 'classnames';
import React, { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { iframeScrollToTop } from '../../../common/utils/Utils';
import iconCartaoValueCareMINI from '../../assets/images/icons/Menu-Os_Meus_Servicos/03_Value_QR.svg';
import iconHistoricoViaturaMINI from '../../assets/images/icons/Menu-Os_Meus_Servicos/04_Historico.svg';
import iconServiceInclusiveMINI from '../../assets/images/icons/Menu-Os_Meus_Servicos/05_Service_Inclusive.svg';
import iconOfertasCampanhasMINI from '../../assets/images/icons/Menu-Os_Meus_Servicos/06_Ofertas_Campanhas.svg';
import iconMarcacaoServicoMINI from '../../assets/images/icons/Menu-Os_Meus_Servicos/07_Marcar_Servico.svg';
import iconSimuladorPneusMINI from '../../assets/images/icons/Menu-Os_Meus_Servicos/08_Simulador_Pneus.svg';
import iconRecallMINI from '../../assets/images/icons/Menu-Os_Meus_Servicos/09_Recall.svg';
import iconAdicionarViatura2013MINI from '../../assets/images/icons/Menu-Os_Meus_Servicos/10_Adicionar_Viatura_Anterior.svg';
import iconEventosMINI from '../../assets/images/icons/Menu-Os_Meus_Servicos/11_Eventos.svg';
import iconPerfilMINI from '../../assets/images/icons/Menu-Os_Meus_Servicos/12_Perfil.svg';
import iconTerminarSessaoMINI from '../../assets/images/icons/Menu-Os_Meus_Servicos/13_Terminar_Sessao.svg';
import iconAdicionarViatura2013 from '../../assets/images/icons/Menu-Os_Meus_Servicos/AdicionarViaturaAnteriora2013.svg';
import iconServiceInclusive from '../../assets/images/icons/Menu-Os_Meus_Servicos/BMWServiceInclusive.svg';
import iconUsadoImportado from '../../assets/images/icons/Menu-Os_Meus_Servicos/BMWUsadoouImportado.svg';
import iconCartaoValueCare from '../../assets/images/icons/Menu-Os_Meus_Servicos/CartaoValueService5Electronico.svg';
import iconEventos from '../../assets/images/icons/Menu-Os_Meus_Servicos/eventos.svg';
import iconHistoricoViatura from '../../assets/images/icons/Menu-Os_Meus_Servicos/HistoricodaViatura.svg';
import iconMarcacaoServico from '../../assets/images/icons/Menu-Os_Meus_Servicos/MarcacaodeServico.svg';
import iconOfertasCampanhas from '../../assets/images/icons/Menu-Os_Meus_Servicos/OfertaseCampanhas.svg';
import iconPerfil from '../../assets/images/icons/Menu-Os_Meus_Servicos/OmeuPerfil.svg';
import iconRecall from '../../assets/images/icons/Menu-Os_Meus_Servicos/RecalleAcoesTecnicas.svg';
import iconSimuladorPneus from '../../assets/images/icons/Menu-Os_Meus_Servicos/SimuladordePneus.svg';
import iconTerminarSessao from '../../assets/images/icons/Menu-Os_Meus_Servicos/TerminarSessao.svg';
import { config } from '../../common/';
import { useRouter } from '../../common/RouterHooks';
import LandingContainer from './containers/LandingContainer';
import css from './Landing.scss';

interface MenuLink {
    title: string;
    to: any;
    enabled: boolean;
    icon: any;
    anchor?: boolean | null;
}

const Landing: React.FC = () => {
    const { t } = useTranslation();
    const routeProps = useRouter();

    useEffect(() => {
        iframeScrollToTop();
    }, []);

    // 2023-10: Removed tracy as per BMW's request
    // Utils.CallTracyPage();
    // const isDevice = /ipad|iphone|ipod|android/i.test(navigator.userAgent.toLowerCase());

    const linksBMW: MenuLink[][] = [
        [
            { title: t(`home:landing.icons.serviceInclusive`), to: `${config.BaseURL}/maintenance/packs`, enabled: config.Show_maintenance_packs, icon: iconServiceInclusive, anchor: false },
            { title: t(`home:landing.icons.valueService5`), to: `${config.BaseURL}/valueandcare`, enabled: config.Show_vc_packs, icon: iconServiceInclusive, anchor: false },
            { title: t(`home:landing.icons.cartaoValueCare`), to: `${config.BaseURL}/cards`, enabled: config.Show_Cards === true, icon: iconCartaoValueCare, anchor: false },
            { title: t(`home:landing.icons.simuladorPneus`), to: `${config.BaseURL}/tyre/simulator`, enabled: config.Show_tyresSimulator, icon: iconSimuladorPneus, anchor: false },
            { title: t(`home:landing.icons.marcacaoServico`), to: config.LinkAppointmentsSite, enabled: config.Show_serviceSchedule, icon: iconMarcacaoServico, anchor: true },
        ],
        [
            { title: t(`home:landing.icons.valueRepair`), to: `${config.BaseURL}/valuerepair`, enabled: config.Show_valueRepair, icon: iconMarcacaoServico, anchor: false },
            { title: t(`home:landing.icons.recall`), to: config.RecallAcoesTecnicasURL, enabled: config.Show_recallAndTAs, icon: iconRecall, anchor: true },
            { title: t(`home:landing.icons.marcacaoServico`), to: config.LinkAppointmentsSite, enabled: config.Show_serviceSchedule, icon: iconMarcacaoServico, anchor: true },
        ],
        [
            { title: t(`home:landing.icons.usadoImportado`), to: `${config.BaseURL}/offers/${config.BemVindoOfferCode}`, enabled: config.Show_bemvindo, icon: iconUsadoImportado, anchor: false },
            { title: t(`home:landing.icons.ofertasCampanhas`), to: `${config.BaseURL}/offers`, enabled: config.Show_offers, icon: iconOfertasCampanhas, anchor: false },
            { title: t(`home:landing.icons.eventos`), to: `${config.BaseURL}/events`, enabled: config.Show_eventos, icon: iconEventos, anchor: false },
        ],
        [
            { title: t(`home:landing.icons.perfil`), to: `${config.BaseURL}/profile`, enabled: true, icon: iconPerfil, anchor: false },
            { title: t(`home:landing.icons.historicoViatura`), to: `${config.BaseURL}/contractsinvoices`, enabled: config.Show_contractsinvoices, icon: iconHistoricoViatura, anchor: false },
            { title: t(`home:landing.icons.adicionarViatura2013`), to: `${config.BaseURL}/profile?op=addVehicle`, enabled: config.Show_addBefore2013, icon: iconAdicionarViatura2013, anchor: false },
        ],
    ];

    const linksMINI: MenuLink[][] = [
        [
            { title: t(`home:landing.icons.serviceInclusive`), to: `${config.BaseURL}/maintenance/packs`, enabled: config.Show_maintenance_packs, icon: iconServiceInclusiveMINI, anchor: false },
            { title: t(`home:landing.icons.valueService5`), to: `${config.BaseURL}/valueandcare`, enabled: config.Show_vc_packs, icon: iconServiceInclusiveMINI, anchor: false },
            { title: t(`home:landing.icons.cartaoValueCare`), to: `${config.BaseURL}/cards`, enabled: config.Show_Cards === true, icon: iconCartaoValueCareMINI, anchor: false },
            { title: t(`home:landing.icons.simuladorPneus`), to: `${config.BaseURL}/tyre/simulator`, enabled: config.Show_tyresSimulator, icon: iconSimuladorPneusMINI, anchor: false },
            { title: t(`home:landing.icons.marcacaoServico`), to: config.LinkAppointmentsSite, enabled: config.Show_serviceSchedule, icon: iconMarcacaoServicoMINI, anchor: true },
        ],
        [
            { title: t(`home:landing.icons.valueRepair`), to: `${config.BaseURL}/valuerepair`, enabled: config.Show_valueRepair, icon: iconMarcacaoServicoMINI, anchor: false },
            { title: t(`home:landing.icons.recall`), to: config.RecallAcoesTecnicasURL, enabled: config.Show_recallAndTAs, icon: iconRecallMINI, anchor: true },
            { title: t(`home:landing.icons.marcacaoServico`), to: config.LinkAppointmentsSite, enabled: config.Show_serviceSchedule, icon: iconMarcacaoServicoMINI, anchor: true },
        ],
        [
            { title: t(`home:landing.icons.ofertasCampanhas`), to: `${config.BaseURL}/offers`, enabled: config.Show_offers, icon: iconOfertasCampanhasMINI, anchor: false },
            { title: t(`home:landing.icons.eventos`), to: `${config.BaseURL}/events`, enabled: config.Show_eventos, icon: iconEventosMINI, anchor: false },
        ],
        [
            { title: t(`home:landing.icons.perfil`), to: `${config.BaseURL}/profile`, enabled: true, icon: iconPerfilMINI, anchor: false },
            { title: t(`home:landing.icons.historicoViatura`), to: `${config.BaseURL}/contractsinvoices`, enabled: config.Show_contractsinvoices, icon: iconHistoricoViaturaMINI, anchor: false },
            { title: t(`home:landing.icons.adicionarViatura2013`), to: `${config.BaseURL}/profile?op=addVehicle`, enabled: config.Show_addBefore2013, icon: iconAdicionarViatura2013MINI, anchor: false },
        ],
    ];

    const renderColumn = (links: MenuLink[]) => {
        return (
            <React.Fragment>
                {links.map((link, k) =>
                    <li key={k} className={link.enabled === true ? '' : css.disabledLink}>
                        <img src={link.icon} alt={link.title} />
                        {link.anchor === true && (<a href={link.to} target="_blank">{link.title}</a>)}
                        {link.anchor === false && (<Link to={link.to}>{link.title}</Link>)}
                    </li>)
                }
            </React.Fragment>
        );
    };

    return (
        <LandingContainer t={t} routeProps={routeProps}>
            {(props) => {
                return (
                    <React.Fragment>
                        <div className={classNames(['grid-container', 'menu-os-meus-servicos', 'margin-bottom-3'])}>
                            <div className={classNames(['grid-x', 'grid-margin-x'])}>
                                <div className={'cell'}>
                                    <h1>{t(`home:landing.myBrand`)}</h1>
                                </div>
                                <div className={'cell'}>
                                    <h2>{t(`home:landing.myBrandText`)}</h2>
                                </div>
                                <div className={classNames(['cell', 'large-3', 'medium-3', 'small-12'])}>
                                    <h5>{t(`home:landing.menuHeader1`)}</h5>
                                    <ul className={classNames(['vertical', 'menu'])}>
                                        {config.BrandEnv === 'MINI' ? renderColumn(linksMINI[0]) : renderColumn(linksBMW[0])}
                                    </ul>
                                </div>
                                <div className={classNames(['cell', 'large-3', 'medium-3', 'small-12'])}>
                                    <h5>{t(`home:landing.menuHeader2`)}</h5>
                                    <ul className={classNames(['vertical', 'menu'])}>
                                        {config.BrandEnv === 'MINI' ? renderColumn(linksMINI[1]) : renderColumn(linksBMW[1])}
                                    </ul>
                                </div>
                                <div className={classNames(['cell', 'large-3', 'medium-3', 'small-12'])}>
                                    <h5>{t(`home:landing.menuHeader3`)}</h5>
                                    <ul className={classNames(['vertical', 'menu'])}>
                                        {config.BrandEnv === 'MINI' ? renderColumn(linksMINI[2]) : renderColumn(linksBMW[2])}
                                    </ul>
                                </div>
                                <div className={classNames(['cell', 'large-3', 'medium-3', 'small-12'])}>
                                    <h5>{t(`home:landing.menuHeader4`)}</h5>
                                    <ul className={classNames(['vertical', 'menu'])}>
                                        {config.BrandEnv === 'MINI' ? renderColumn(linksMINI[3]) : renderColumn(linksBMW[3])}
                                        <li>
                                            <hr />
                                        </li>
                                        <li>
                                            <img src={config.BrandEnv === 'MINI' ? iconTerminarSessaoMINI : iconTerminarSessao} alt={t(`home:landing.icons.terminarSessao`)} />
                                            <a href="#" onClick={props.onLogout} title={t(`home:landing.icons.terminarSessao`)}>
                                                {t(`home:landing.icons.terminarSessao`)}
                                            </a>
                                        </li>
                                    </ul>
                                </div>
                                { /*
                                    <div className={classNames(['cell', 'large-4', 'small-6'])}>
                                            <div className={'media-object'}>
                                                <Link to={`${config.BaseURL}/subscription/packs`}>
                                                    <div className={classNames(['media-icon', 'top'])}>
                                                        <div className={'thumbnail'}>
                                                            <MenuIconSubscription />
                                                        </div>
                                                    </div>
                                                    <div className={classNames(['media-object-section', 'bottom'])}>
                                                        <h4>{t(`home:landing.subscriptionPackHeader`)}</h4>
                                                        <p>{t(`home:landing.subscriptionPackDesc`)}</p>
                                                    </div>
                                                </Link>
                                            </div>
                                        </div>
                                */ }
                            </div>
                        </div>
                    </React.Fragment>
                );
            }}
        </LandingContainer >
    );
};

export default Landing;
